import {gql} from '@apollo/client'

export const CREATE_COMMISSION_REPORT_DETAIL = gql`
  mutation createCommissionReportDetail($input: commission_report_detail_input!) {
    commissionReportDetailCreateMutation(input: $input) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_COMMISSION_REPORT_DETAIL = gql`
  mutation updateCommissionReportDetail($id: ID!, $input: commission_report_detail_input!) {
    commissionReportDetailUpdateMutation(id: $id, input: $input) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_COMMISSION_REPORT_DETAIL = gql`
  mutation deleteCommissionReportDetail($id: ID!) {
    commissionReportDetailDeleteMutation(id: $id) {
      success
      errors {
        message
      }
    }
  }
`

export const ADD_NOTE_COMMISSION_DETAIL = gql`
  mutation CreateCommissionReportNote($input: commission_report_note_input!) {
    createCommissionReportNote(input: $input) {
      success
      errors {
        message
      }
    }
  }
`
